import React from 'react';
import { Container } from 'typedi';

export const ContainerContext = React.createContext(Container);
